<script lang="ts">
    import type {EmailTemplate} from "$lib/types/EmailTemplate";
    import {templateDocuments} from "$lib/stores/templateDocuments";
    import {tariffs} from "$lib/stores/tariffs";
    import {formDataPost, post} from "$lib/api";
    import {getEmailTemplates} from "$lib/calls/mail";
    import generateContractPreview from "$lib/utils/templating/generateContractPreview";
    import {createEventDispatcher, onMount} from "svelte";
    import {getTariffs} from "$lib/calls/tariff";
    import {allUnits} from "$lib/stores/unit";
    import {getCostCenters, getUnits} from "$lib/calls/unit";
    import {unitQualifications} from "$lib/calls/qualification";
    import {getDocumentTemplates} from "$lib/calls/settings";
    import {mailTemplates} from "$lib/stores/mailTemplates";
    import dayjs from "dayjs";
    import {formatCurrency} from "$lib/utils/currency";
    import {contractTypes} from "$lib/utils/templating/contractTypes";
    import {Alert, Input, Label, Select, Toggle} from "flowbite-svelte";
    import InfoBox from "$items/InfoBox.svelte";
    import VerticalGrid from "$lib/components/VerticalGrid.svelte";
    import type {Contract, Employee} from "$lib/types/employee";
    import {qualifications} from "$lib/stores/qualifications";
    import hasEmploymentStatus from "$lib/utils/hasEmploymentStatus";
    import {writable, type Writable} from "svelte/store";
    import {blur} from "svelte/transition";

    export let employee: Employee;

    export let contract: Contract= {currentHistory: {
            startDate: dayjs().add(1, 'month').date(1).format('YYYY-MM-DD'),
            endDate: dayjs().year() + '-12-31',

            hiredAs: 'ServicehilfKraft',

        }};

    export let minTariffId:number|undefined;

    export let sharedState: Writable<{loading: boolean, preview: Blob | null, formComplete: boolean, triggerPreview: boolean, triggerContract: boolean}> = writable({
        loading: false,
        preview: null,
        formComplete: false,
        triggerPreview: false,
        triggerContract: false
    })

    sharedState.subscribe(x => {
        if(x.triggerPreview && !x.preview && !x.loading){
            generatePreview()
            // contractForm.requestSubmit()
        } else if(x.triggerContract && !x.loading && !contract.history){
            $sharedState.triggerContract = false
            submitNewContract()
        }
    })



    let currentTariff:any = null

    let files:FileList = [];

    // let qualifications:any[] = [];
    let costCenters = [];
    let customVariables = {
        limited: true,
        employmentPartTimeFullTime: 'Teilzeit'
    }

    let contractForm: HTMLFormElement;


    let dispatch = createEventDispatcher();


    $: template = $templateDocuments.find(x => x.contractType === contract?.contractType)


    $: {
        if(contractForm && contract.contractType && template && !$sharedState.formComplete){
            const valid = contract.currentHistory.qualificationId && contract.currentHistory.startDate && contract.currentHistory.endDate && contract.currentHistory.costCenterId
            $sharedState = {...$sharedState, formComplete: valid}
        }
    }
    $: minWorkdays = contract.contractType === 'fulltime' ? 4.5 : (contract.contractType === 'workingstudent' || contract.contractType === 'parttime' ? 2 : 1)
    $: maxWorkdays = contract.contractType === 'parttime' ? 4 : ((contract.contractType === 'workingstudent' ? 4 : (contract.contractType === 'minijob' ? 1 : 7)))

    const setTariff = (tariffId) => {
        currentTariff = $tariffs.find(x => x.id === parseInt(tariffId))
        contract.currentHistory.paymentOnAccount = currentTariff.paymentOnAccount
        contract.currentHistory.workHoursPerDay = currentTariff.hoursPerDay
        contract.currentHistory.workDaysPerWeek = currentTariff.workingDaysPerWeek > minWorkdays ? currentTariff.workingDaysPerWeek : minWorkdays
        contract.currentHistory.ptoDays = currentTariff.ptoDays
        contract.currentHistory.trialPeriodMonths = 6
    }

    const submitNewContract = async () => {
        $sharedState.loading = true;
        post('/employee/' + employee.uuid + '/contract', {
            contractType: contract.contractType,
            ...contract.currentHistory,
            endDate: customVariables.limited ? contract.currentHistory.endDate : null
        }).then(async (res) => {

            const result = await formDataPost('/document/contract', {
                file: files && files.length > 0 ? files[0] : $sharedState.preview,
                connectedEntity: 'EmployeeContract',
                entityId: res.id,
                historyId: res.currentHistory.id
            })
            contract = result.contract
            employee.contracts = [...employee.contracts, contract]
            $sharedState.loading = false;
            dispatch('history', contract.currentHistory)
        })


    }



    let preview: Blob | null;
    const generatePreview = async () => {
        $sharedState.loading = true;
        const currentQualification = $qualifications.find(x => x.id === contract.currentHistory.qualificationId)
        // contract-fields in variables
        contract.currentHistory.group = currentQualification?.payGroup
        contract.currentHistory.hiredAs =  currentQualification?.title.match(/[A-Z]{3}\s(\w*)/)?.[1]
        contract.currentHistory.qualification =  currentQualification

        customVariables.employmentPartTimeFullTime = contract.contractType === 'fulltime' ? 'Vollzeit' : 'Teilzeit'

        $sharedState.preview = await generateContractPreview(employee, contract, contract.currentHistory, customVariables)

        $sharedState.loading = false;

    }




    onMount(async () => {
        if($tariffs.length === 0){
            $tariffs = await getTariffs();
        }
        if($allUnits.length === 0){
            $allUnits = await getUnits();
        }

        if($qualifications.length === 0 || $qualifications.find(x => x.unitId === employee.unitId) === undefined){
            $qualifications = [...$qualifications, ...await unitQualifications(employee.unitId)]
        }

        if($templateDocuments.length === 0){
            $templateDocuments = await getDocumentTemplates()
            console.log({tmpl: $templateDocuments})
        }
        costCenters = await getCostCenters()

        if(!contract.currentHistory.costCenterId){
            contract.currentHistory.costCenterId = costCenters.filter(x => x.unitId === employee.unitId).find(x => x.name.includes('ANÜ'))?.id
        }

        /*if($mailTemplates.length === 0){
            $mailTemplates = await getEmailTemplates()
        }
        if(hasEmploymentStatus(employee, 'active')) {
            mailTemplate = $mailTemplates.find(x => x.level === 'active' && x.name.toLowerCase().includes('typänderung_sent'));
        } else if(hasEmploymentStatus(employee, 'inactive')) {
            mailTemplate = $mailTemplates.find(x => x.level === 'contractible' && x.name.toLowerCase().includes('wiedereintritt_sent'));
        } else if($mailTemplates.filter(x => x.level === 'contractible' || x.level === 'active').length === 1) {
            mailTemplate = $mailTemplates.find(x => x.level === (employee.employmentStatus === 'active' ? 'active' : 'contractible'));
        } else {
            mailTemplate = $mailTemplates.find(x => x.level === 'contractible' && x.name.toLowerCase().includes('mav_angebot_sent'));
        }*/
        if(contract.currentHistory.tariffId){
            setTariff(contract.currentHistory.tariffId)
        }
        if(typeof minTariffId === 'undefined' && contract.currentHistory?.tariffId){
            minTariffId = contract.currentHistory.tariffId
        }

    })
</script>
<div class="w-full">
    <form bind:this={contractForm} on:submit|preventDefault={submitNewContract} class="w-full">
        <Label class="space-y-2">
            <span>Tarif</span>
            <Select on:change={(ev) =>setTariff(ev.target.value)} required bind:value={contract.currentHistory.tariffId}>
                {#if minTariffId}
                    <!-- no determinate min-tariff -->
                    {#each $tariffs.filter(x => x.unitId === employee.unitId && x.visible).filter(x => x.wagePerHour >= $tariffs.find(y => y.id === minTariffId).wagePerHour).sort((a, b) => a.validFrom.value - b.validFrom.value) as tariff}
                        <option value={tariff.id}>{tariff.name} (ab {dayjs(tariff.validFrom.value).format('MM.YYYY')})</option>
                    {/each}
                {:else}
                    <!-- min-tariff set -->
                    {#each $tariffs.filter(x => x.unitId === employee.unitId && x.visible).sort((a, b) => a.validFrom.value - b.validFrom.value) as tariff}
                        <option value={tariff.id}>{tariff.name} (ab {dayjs(tariff.validFrom.value).format('MM.YYYY')})</option>
                    {/each}
                {/if}

            </Select>
        </Label>
        {#if currentTariff}
            <div transition:blur class="mt-5 border rounded p-2">
                <VerticalGrid>
                    <!--                            <InfoBox title="Gültig ab" value={dayjs(currentTariff.validFrom.value).format('DD.MM.YYYY')} />-->
                    <InfoBox title="Stundenlohn" value={formatCurrency(currentTariff.wagePerHour, 'EUR')} />
                    <div>
                        <div>
                            <span class="leading-6 text-lg text-gray-500">Zuschläge</span>
                        </div>
                        <div></div>
                        <div class="text-sm flex justify-between text-neutral-600">
                            <span>Standardzuschlag</span>
                            <span>0%</span>
                        </div>

                        <div class="text-sm flex justify-between text-neutral-600">
                            <span>Sonntagszuschlag</span>
                            <span>{currentTariff.addedPercentageSunday}%</span>
                        </div>

                    </div>

                    <svelte:fragment slot="right">
                        <!--                                <InfoBox title="Unit" value={units.find(x => x.id === currentTariff.unitId)?.name || ''} />-->
                        <InfoBox title="A-conto Zahlung" value={formatCurrency(currentTariff.paymentOnAccount, 'EUR')} />
                        <div class="lg:pt-7">
                            <div class="text-sm flex justify-between text-neutral-600">
                                <span>Nachtzuschlag</span>
                                <span>{currentTariff.addedPercentageNight}%</span>
                            </div>
                            <div class="text-sm flex justify-between text-neutral-600">
                                <span>Feiertagszuschlag</span>
                                <span>{currentTariff.addedPercentageHoliday}%</span>
                            </div>
                        </div>

                    </svelte:fragment>
                </VerticalGrid>

            </div>
            {#if $sharedState.preview}
                <div transition:blur class="mt-5 border rounded p-2">
                    <VerticalGrid>
                        <!--                            <InfoBox title="Gültig ab" value={dayjs(currentTariff.validFrom.value).format('DD.MM.YYYY')} />-->
                        <InfoBox title="Qualifikation" value={$qualifications.find(x => x.id === contract.currentHistory.qualificationId)?.title} />
                        <div>
                            <div>
                                <span class="leading-6 text-lg text-gray-500">Vertragsdaten</span>
                            </div>
                            <div></div>
                            <div class="text-sm flex justify-between text-neutral-600">
                                <span>Art</span>
                                <span>{contractTypes.find(x => x.value === contract.contractType).name}</span>
                            </div>

                            <div class="text-sm flex justify-between text-neutral-600">
                                <span>Befristung</span>
                                <span>{customVariables.limited ?  contract.currentHistory.limitationReason : 'Unbefristet'}</span>
                            </div>

                        </div>

                        <svelte:fragment slot="right">
                            <!--                                <InfoBox title="Unit" value={units.find(x => x.id === currentTariff.unitId)?.name || ''} />-->
                            <InfoBox title="Zeitraum" value={dayjs(contract.currentHistory.startDate).format('DD.MM.YYYY') + (customVariables.limited ? ' - ' + dayjs(contract.currentHistory.endDate).format('DD.MM.YYYY') : '')} />
                            <div class="lg:pt-7">
                                <div class="text-sm flex justify-between text-neutral-600">
                                    <span>Kostenstelle</span>
                                    <span>{costCenters.find(x => x.id === contract.currentHistory.costCenterId)?.name}</span>
                                </div>
                                <div class="text-sm flex justify-between text-neutral-600">
                                    <span>Tage/Woche</span>
                                    <span>{contract.currentHistory.workDaysPerWeek}</span>
                                </div>

                            </div>

                        </svelte:fragment>
                    </VerticalGrid>


                </div>
            {:else}
                <Label class="space-y-2 my-3">
                    <span>Qualifikation</span>
                    <Select required bind:value={contract.currentHistory.qualificationId}>
                        {#each $qualifications.filter(x => currentTariff.qualifications.map(y => y.qualificationId).includes(x.id)) as qualification}
                            <option value={qualification.id}>{qualification.title}</option>
                        {/each}
                    </Select>
                </Label>
                {#if contract.currentHistory.qualificationId}
                    <div transition:blur|global class="grid grid-cols-2 gap-3">
                        <Label class="space-y-2">
                            <span>Vertragsart</span>
                            <Select on:change={() => contract.currentHistory.workDaysPerWeek = minWorkdays} required bind:value={contract.contractType} >
                                <option value="shortterm">Kurzfristige Beschäftigung</option>
                                <option value="fulltime">Vollzeit</option>
                                <option value="parttime">Teilzeit</option>
                                <option value="workingstudent">Werkstudent</option>
                                <option value="minijob">MINI job</option>
                                <option value="internship">Praktikum</option>
                            </Select>
                        </Label>
                        <div class="pt-8">
                            <Toggle bind:checked={customVariables.limited}>{customVariables.limited ? 'Befristet' : 'Unbefristet'}</Toggle>
                        </div>
                        <Label class="space-y-2">
                            <span>Beginn der Tätigkeit</span>
                            <Input on:change={() => contract.currentHistory.endDate = dayjs(contract.currentHistory.startDate.match(/(\d{4})/)[0] +'-12-31').format('YYYY-MM-DD')} type="date" min={dayjs(currentTariff.validFrom.value).format('YYYY-MM-DD')} required  bind:value={contract.currentHistory.startDate}/>
                        </Label>
                        {#if customVariables.limited}
                            <Label class="space-y-2">
                                <span>Ende der Tätigkeit</span>
                                <Input type="date" min={contract.currentHistory.startDate} required bind:value={contract.currentHistory.endDate}/>
                            </Label>

                            <Label class="space-y-2">
                                <span>Befristungsgrund</span>
                                <Select required bind:value={contract.currentHistory.limitationReason}>
                                    <option selected value="Wunsch des Arbeitnehmers">Wunsch des Arbeitnehmers</option>
                                    <option value="Student/Vereinbarkeit Studium und Beruf">Student/Vereinbarkeit Studium und Beruf</option>
                                    <option value="ohne Sachgrund">ohne Sachgrund</option>
                                </Select>
                            </Label>
                        {/if}
                        <Label class="space-y-2">
                            <span>Arbeitstage pro Woche</span>
                            <Input step="0.5" min={minWorkdays} max={maxWorkdays} type="number" bind:value={contract.currentHistory.workDaysPerWeek} required />
                        </Label>
                        <Label class="space-y-2">
                            <span>Kostenstelle</span>
                            <Select required bind:value={contract.currentHistory.costCenterId}>
                                {#each costCenters.filter(x => x.unitId === employee.unitId).sort((a, b) => a.name.localeCompare(b.name)) as costCenter}
                                    <option value={costCenter.id} selected={costCenter.unitId === employee.unitId}>{costCenter.name}</option>
                                {/each}
                            </Select>
                        </Label>
                        <Label class="space-y-2">
                            <span>Stunden pro Arbeitstag</span>
                            <Input step="0.25" type="number" bind:value={contract.currentHistory.workHoursPerDay} required disabled/>
                        </Label>

                        <Label class="space-y-2">
                            <span>Stunden pro Monat</span>
                            <Input type="number" value={(contract.currentHistory.workHoursPerDay * contract.currentHistory.workDaysPerWeek * 4.3).toFixed(0)} required disabled/>
                        </Label>
                        <Label class="space-y-2">
                            <span>Probezeit in Monaten</span>
                            <Input type="number" bind:value={contract.currentHistory.trialPeriodMonths} required disabled/>
                        </Label>
                        <Label class="space-y-2">
                            <span>Urlaubstage</span>
                            <Input step="0.25" type="number" bind:value={contract.currentHistory.ptoDays} required disabled/>
                        </Label>
                        <Label class="space-y-2">
                            <span>Entgeldgruppe</span>
                            <Input disabled value={$qualifications.find(x => x.id === contract.currentHistory.qualificationId)?.payGroup} />
                        </Label>

                    </div>
                {/if}
            {/if}

            {#if contract.contractType && !template}
                <div class="mt-3">
                    <Alert color="red">
                        <span class="font-medium">Fehlende Vertragsvorlage oder fehlende Daten!</span>
                        Keine Vertragsvorlage verfügbar. Bitte an Administration wenden oder Daten prüfen.
                    </Alert>
                </div>

            {/if}

        {/if}

    </form>

</div>